// Endpoints for the Channels Playground. Resolved from build-time env so
// the admin app exercises the channel infra of whatever environment it
// was built for (dev admin -> dev infra, prod admin -> prod infra). The
// defaults are the dev demo origins so local `pnpm dev` and the dev
// deploy work with no extra config.
//
// Integration tokens are NOT configured here — they're entered (or picked
// from a real dealership channel) at runtime in each playground view.
//
// Note: the widget WS gateway lives on the *main* backend
// (`api.<root>`, mounted at /api/v1/widget/lead) and `widget.js` on the
// widget CDN (`widget.<root>`) — both different hosts from the admin
// API, so they get their own vars rather than deriving from
// VITE_ADMIN_API_BASE_URL. WS origin -> ws(s) mirrors
// apps/widget/src/widget/constants.ts.

const trim = (value: string): string => value.replace(/\/+$/, "");

const WS_ORIGIN = trim(
  import.meta.env.VITE_PLAYGROUND_WS_URL ?? "https://api.app.dev.lumika.ai",
);

/** WSS endpoint for the widget/api channel gateway. */
export const WS_URL = `${WS_ORIGIN.replace(/^http/, "ws")}/api/v1/widget/lead`;

/** Deployed widget bundle (`widget.js`) loaded by the website-widget iframes. */
export const WIDGET_URL = `${trim(
  import.meta.env.VITE_PLAYGROUND_WIDGET_URL ?? "https://widget.app.dev.lumika.ai",
)}/widget.js`;
